/**
 * Type/family of crop (used to display icon)
 */
export enum CropType {
  CORN = 'corn',
  VINE = 'vine',
  WHEAT = 'wheat',
  BARLEY = 'barley',
  LUCERNE = 'lucerne',
  SUNFLOWER = 'sunflower',
  RAPESEED = 'rapeseed',
  SOY = 'soy',
  RAPE = 'rape',
  TOMATO = 'tomato',
  TURF = 'turf',
  OLIVE_TREE = 'olive_tree',
  COTTON = 'cotton',
  POTATO = 'potato',
  STONE_FRUIT_TREE = 'stone_fruit_tree',
  SUGAR_BEET = 'sugar_beet',
}
